<template>
  <div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="version" label="版本号" width="180">
      </el-table-column>
      <el-table-column prop="build" label="构件版本号" width="180">
      </el-table-column>
      <el-table-column prop="url" label="下载地址">
      </el-table-column>
      <el-table-column prop="description" label="更新日志">
      </el-table-column>
      <el-table-column prop="date" label="发布时间">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Global from "../Global";

  export default {
    name: 'versionRecord',
    data() {
      return {
        tableData: []
      }
    },
    mounted() {
      let that = this;
      this.axios({
        method: 'GET',
        url: Global.accountUrl + '/Apk/getVersionRecords'
      })
      .then(function(response){
        if(response.data.code == 200) {
          that.tableData = response.data.data;
        }
        else {
          that.$message.error('请求数据失败');
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/version/VersionRecord.vue